export default __webpack_public_path__ + "static/media/DisneyPlus_EmotionalBanner.605bb33e.png";